import React from "react";
import { Link } from "react-router-dom";

const NeedHelp = () => {
    return (
        <>
            <div className="pt-10 pb-10 bg-black text-gray-400">
                <div className="max-w-4xl mx-auto px-6">
                    <h1 className="text-3xl font-bold mb-8 text-green">FAQs – Game Gems App</h1>
                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">1. What is Game Gems?</h2>
                        <p className="mb-4">Game Gems is a fun and rewarding mobile app that lets you collect virtual gems by tapping, playing, or participating in partner games. You can use these gems to unlock cool perks, bonus items, or exclusive offers.</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">2. Is Game Gems free to use?</h2>
                        <p className="mb-4">Yes! Game Gems is completely free to download and play. No purchases are required to collect gems or participate in the activities.</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">3. How do I earn gems?</h2>
                        <p className="mb-4">You can earn gems by:</p>
                        <ul className="list-disc list-inside mb-4 space-y-1">
                            <li>Tapping the mine button daily</li>
                            <li>Completing in-app tasks</li>
                            <li>Inviting friends</li>
                            <li>Playing partnered mini-games</li>
                            <li>Participating in events or challenges</li>
                        </ul>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">4. What can I do with the gems I earn?</h2>
                        <p className="mb-4">You can use your collected gems to unlock rewards, boost your progress, access premium features, or enter special contests (depending on app updates).</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">5. Can I exchange gems for real money?</h2>
                        <p className="mb-4">No. Gems are virtual and for entertainment purposes only. They do not carry any real-world monetary value.</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">6. Is Game Gems safe and secure?</h2>
                        <p className="mb-4">Absolutely. We take your privacy seriously. We do not collect unnecessary data, and all usage complies with Google Play’s policies. See our <Link className="text-green" to="/privacy">Privacy Policy</Link> for full details.</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">7. Why is my gem balance not updating?</h2>
                        <p className="mb-4">Try refreshing the app or restarting your device. If the issue persists, please contact our support team at <Link className="text-green" to="mailto:gamegems.help@gmail.com">gamegems.help@gmail.com</Link>.</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">8. How can I invite my friends?</h2>
                        <p className="mb-4">Go to the "Invite" section in the app, share your referral link, and earn bonus gems when your friends join and start mining!</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">9. Do I need an internet connection to play?</h2>
                        <p className="mb-4">Yes, an internet connection is required to access features, sync progress, and participate in real-time updates and offers.</p>
                    </div>

                    <div className="faq">
                        <h2 className="text-2xl font-semibold mt-8 mb-2 text-white">10. I found a bug. What should I do?</h2>
                        <p className="mb-4">We appreciate your help in improving Game Gems. Please report bugs or suggestions to our team at <Link className="text-green" to="mailto:gamegems.help@gmail.com">gamegems.help@gmail.com</Link>.</p>
                    </div>

                </div>
            </div>
        </>
    )
}

export default NeedHelp;